import { MutationTree } from 'vuex';
import { MessageCategoriesState } from './types';

export const mutations: MutationTree<MessageCategoriesState> = {
    setMessageCategories: (state, data) => {
        state.messageCategories = data;
    },
    setMessageCategoryItem: (state, data) => {
        state.messageCategoryItem = data;
    },
    setAllowedTransports: (state, data) => {
        state.allowedTransports = data;
    },
    setRegexRulesItem: (state, data) => {
        state.regexRulesItem = data;
    }
};
